import { useContext } from "react";
import {
    Box,
    Container,
    Typography,
    Stack,
    Divider,
    IconButton,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import lightLogo from '../../../Images/fouchain-logo-light.svg';
import darkLogo from "../../../Images/fouchain-logo-dark.svg";
import { ThemeContext } from "../../DarkMode/ThemeProvider";
import FooterBgImg from '../../../Images/home/footer-bg-img.webp'


const footerLinks = [
    {
        title: "Companies",
        links: [
            { label: "Home", sectionId: "/" },
            { label: "About Us", sectionId: "about-us-id" },
            { label: "Why Choose us", sectionId: "feature-id" },
            { label: "How its work", sectionId: "how-it-works-id" },
            { label: "Security", sectionId: "security-id" },
            { label: "FAQ", sectionId: "faq-id" },
        ],
    },
    {
        title: "Products",
        links: [
             { label: "Portfolio", path: "/portfolio" },
            { label: "Markets", path: "/market" },
            { label: "Trade", path: "/trade" },
        ],
    },
    {
        title: "Legal",
        links: [
            { label: "Privacy Policy", path: "/coming-soon" },
            { label: "Terms of Condition", path: "/coming-soon" },
            // { label: "Cookies", path: "/coming-soon" },
        ],
    },
];

const socialIcons = [
    { icon: <FacebookIcon />, link: "#" },
    { icon: <InstagramIcon />, link: "#" },
    { icon: <TwitterIcon />, link: "#" },
    { icon: <YouTubeIcon />, link: "#" },
];

const OuterPageFooter = () => {
    const { isLightMode, handleDarkmode } = useContext(ThemeContext);

    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (!section) return;

        const yOffset = -100;
        const y =
            section.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
    };
    return (
        <Box
            sx={{
                position: "relative",
                background: "radial-gradient(44.06% 50% at 50% 0%, rgba(222, 195, 128, 0.03) 0%, rgba(222, 182, 90, 0.03) 100%), #0C0C0C",
                padding: "65px 25px 25px 25px",
                overflow: "hidden",

                "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url(${FooterBgImg}) `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    opacity: 0.5,
                    zIndex: 0,
                },

                "& > *": {
                    position: "relative",
                    zIndex: 1,
                },
            }}
        >
            <Container maxWidth="xl">
                <Grid2 container spacing={6} sx={{ paddingBottom: '30px' }}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 5, xl: 5 }}>
                        <div className="footer-logo-main">
                            <a href="/"><img src={!isLightMode ? lightLogo : darkLogo} className="logo" width={160} height={80} /></a>
                        </div>

                        <Stack direction="row" spacing={1} sx={{ paddingTop: '30px', justifyContent: { xs: 'center', md: 'start' } }}>
                            {socialIcons.map((item, index) => (
                                <IconButton
                                    key={index}
                                    component="a"
                                    href={item.link}
                                    sx={{
                                        color: "#111827",
                                        transition: "all 0.3s ease",
                                        color: 'rgba(239, 237, 253, 0.60)',
                                        "&:hover": {
                                            color: "#F8BC36 !important",
                                            transform: "translateY(-4px)",
                                        },
                                        "& svg": {
                                            fontSize: "30px",
                                        },
                                    }}
                                >
                                    {item.icon}
                                </IconButton>
                            ))}
                        </Stack>
                    </Grid2>

                    {/* Footer Links */}
                    {footerLinks.map((section) => (
                        <Grid2 key={section.title} size={{ xs: 12, sm: 4, md: 4, lg: 2, xl: 2 }}>
                            <Typography className="gold-color" sx={{ fontSize: 20, fontWeight: 600, mb: 2 }}>
                                {section.title}
                            </Typography>

                            <Stack spacing={2}>
                                {section.links.map((item) => (
                                    <Typography
                                        key={item.label}
                                        component="span"
                                        onClick={() => {
                                            if (item.sectionId) {
                                                scrollToSection(item.sectionId);
                                            } else if (item.path) {
                                                window.location.href = item.path;
                                            }
                                        }}
                                        sx={{
                                            fontSize: 16,
                                            cursor: "pointer",
                                            transition: "all 0.25s ease",
                                            color: 'rgba(239, 237, 253, 0.60)',
                                            "&:hover": {
                                                color: "#F8BC36",
                                                transform: "translateX(6px)",
                                            },
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                ))}
                            </Stack>
                        </Grid2>
                    ))}

                    {/* Follow Us */}
                    {/* <Grid2 size={{ xs: 12, md: 2 }}>
                        <Typography className="colorbg"
                            sx={{
                                fontSize: 18,
                                fontWeight: 600,
                                mb: 2,
                                display: 'inline-block'
                            }}
                        >
                            Follow Us
                        </Typography>

                        <Stack direction="row" spacing={1}>
                            {socialIcons.map((item, index) => (
                                <IconButton
                                    key={index}
                                    component="a"
                                    href={item.link}
                                    sx={{
                                        color: "#111827",
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                            color: "#F8BC36 !important",
                                            transform: "translateY(-4px)",
                                        },
                                    }}
                                >
                                    {item.icon}
                                </IconButton>
                            ))}
                        </Stack>
                    </Grid2> */}
                </Grid2>

                <Divider
                    sx={{
                        my: 3,
                        borderStyle: "dashed",
                        borderColor: "#EFEDFDB2",
                        opacity: 0.6,
                    }}
                />


                {/* <Box
                    sx={{
                        padding: '20px 0px',
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "flex-start", md: "center" },
                        justifyContent: "space-between",
                        gap: 3,
                    }}
                >
                    <Box>
                        <Typography
                            sx={{
                                color: "#fff",
                                fontSize: 22,
                                fontWeight: 600,
                                mb: 1.5,
                            }}
                        >
                            Join our newsletter
                        </Typography>

                        <Typography
                            sx={{
                                color: "rgba(255,255,255,0.6)",
                                fontSize: 14,
                            }}
                        >
                            Keep up to date with everything Reflect
                        </Typography>
                    </Box>
                    <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={1.5}
                        sx={{ width: { xs: "100%", md: "auto" } }}
                    >
                        <TextField
                            type="email"
                            placeholder="Enter your email"
                            variant="outlined"
                            fullWidth
                            sx={{
                                minWidth: { sm: 260 },

                                "& .MuiOutlinedInput-root": {
                                    height: 44,
                                    borderRadius: "10px",
                                    color: "#fff",
                                    backgroundColor: "rgba(255,255,255,0.05)",
                                    transition: "all 0.3s ease",

                                    "& fieldset": {
                                        borderColor: "rgba(255,255,255,0.15)",
                                    },

                                    "&:hover fieldset": {
                                        borderColor: "rgba(219,174,76,0.6)",
                                    },

                                    "&.Mui-focused fieldset": {
                                        borderColor: "#DBAE4C",
                                        boxShadow: "0 0 0 1px rgba(219,174,76,0.4)",
                                    },
                                },
                                "& input::placeholder": {
                                    color: "rgba(255,255,255,0.45)",
                                    fontSize: 14,
                                    opacity: 1,
                                },
                                "& input:-webkit-autofill": {
                                    WebkitBoxShadow: "0 0 0 1000px rgba(20,20,20,0.9) inset",
                                    WebkitTextFillColor: "#fff",
                                    caretColor: "#fff",
                                    borderRadius: "10px",
                                },
                            }}
                        />
                        <div className="golden-btn">
                            <Button
                            >
                                Subscribe
                            </Button>
                        </div>
                    </Stack>
                </Box> */}

                <Typography
                    sx={{
                        fontSize: 15,
                        textAlign: 'center',
                        color: 'rgba(255, 255, 255, 0.80)'
                    }}
                >
                    Copyright ©2026 EMRT MARKETS. All rights reserved.
                </Typography>


            </Container>
        </Box>
    );
};


export default OuterPageFooter